import { render, staticRenderFns } from "./BarcodeScannerHandler.vue?vue&type=template&id=248667f3&scoped=true&lang=pug&"
import script from "./BarcodeScannerHandler.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerHandler.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeScannerHandler.vue?vue&type=style&index=0&id=248667f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248667f3",
  null
  
)

component.options.__file = "BarcodeScannerHandler.vue"
export default component.exports